import { Injectable } from '@angular/core';
import { createFrom, EventService, ProductSearchPage, ProductSearchService } from '@spartacus/core';
import { map, skip, switchMap } from 'rxjs/operators';
import { NavigationEvent } from '@spartacus/storefront';
import { EMPTY } from 'rxjs';
import { GtmGgSearchPageEvent } from './gtm-gg-search-page-event';

@Injectable({
  providedIn: 'root',
})
export class GtmGgSearchPageEventBuilder {
  constructor(
    private eventService: EventService,
    private productSearchService: ProductSearchService
  ) {
    const searchResults$ = this.productSearchService.getResults().pipe(skip(1));

    const gtmGgSearchResultsEventSource = this.eventService.get(NavigationEvent).pipe(
      switchMap((navigationEvent: NavigationEvent) => {
        if (navigationEvent?.semanticRoute !== 'search') {
          return EMPTY;
        }

        return searchResults$.pipe(
          map((searchResults) =>
            createFrom(GtmGgSearchPageEvent, {
              event: 'search-results',
              results: searchResults.pagination?.totalResults ? searchResults.pagination?.totalResults.toString() : '',
              'search-term': searchResults.freeTextSearch ? searchResults.freeTextSearch : '',
            })
          )
        );
      })
    );

    eventService.register(GtmGgSearchPageEvent, gtmGgSearchResultsEventSource);

    const gtmGgSearchPageEventSource = this.eventService.get(NavigationEvent).pipe(
      switchMap((navigationEvent: NavigationEvent) => {
        if (navigationEvent?.semanticRoute !== 'search') {
          return EMPTY;
        }

        return searchResults$.pipe(
          map((searchResults) =>
            createFrom(GtmGgSearchPageEvent, {
              event: 'product-impressions',
              list: 'Search Results',
              ecommerce: {
                impressions: this.getImpressionsFromProductSearchPage(searchResults),
              },
            })
          )
        );
      })
    );

    eventService.register(GtmGgSearchPageEvent, gtmGgSearchPageEventSource);
  }

  getImpressionsFromProductSearchPage(productSearchPage: ProductSearchPage) {
    const impressions: {
      name?: string;
      price?: string;
      list?: string;
      position?: string;
      id?: string;
      brand?: string;
    }[] = [];

    productSearchPage.products?.forEach((product, index) => {
      const impression = {
        name: product.name ? product.name : '',
        price: product.price?.value ? product.price.value.toString() : '',
        list: 'Search Results',
        position: (index + 1).toString(),
        id: product.code ? product.code : '',
        brand: product.manufacturer ? product.manufacturer : '',
      };

      impressions.push(impression);
    });

    return impressions;
  }
}
